(function () {
  function init(root) {
    if (root.dataset.abInit) return;
    root.dataset.abInit = '1';
    var pool = root.querySelector('.ab-rf__pool');
    var cols = root.querySelector('.ab-rf__cols');
    var items = Array.prototype.slice.call(pool.querySelectorAll('.ab-rf__item'));
    var btnWrap = root.querySelector('.ab-rf__more');
    var initial = parseInt(root.getAttribute('data-initial'), 10) || items.length;
    var shown = Math.min(initial, items.length);
    var mq = window.matchMedia('(min-width: 990px)');
    function n() { return mq.matches ? 3 : 2; }
    items.forEach(function (it) {
      var tx = it.querySelector('.ab-rf__tx');
      var rm = it.querySelector('.ab-rf__rm');
      if (!tx || !rm) return;
      rm.addEventListener('click', function () {
        var open = tx.classList.toggle('is-clamp');
        rm.textContent = open ? rm.getAttribute('data-more') : rm.getAttribute('data-less');
      });
    });
    function layout() {
      var count = n(), cs = [];
      cols.innerHTML = '';
      for (var i = 0; i < count; i++) { var c = document.createElement('div'); c.className = 'ab-rf__col'; cols.appendChild(c); cs.push(c); }
      items.slice(0, shown).forEach(function (it) {
        var best = cs[0];
        cs.forEach(function (c) { if (c.offsetHeight < best.offsetHeight) best = c; });
        best.appendChild(it);
        var tx = it.querySelector('.ab-rf__tx'), rm = it.querySelector('.ab-rf__rm');
        if (tx && rm && !it.dataset.abm) {
          it.dataset.abm = '1';
          tx.classList.add('is-clamp');
          if (tx.scrollHeight > tx.clientHeight + 1) rm.classList.add('is-on'); else tx.classList.remove('is-clamp');
        }
      });
      if (btnWrap) btnWrap.classList.toggle('is-hidden', shown >= items.length);
    }
    root.classList.add('is-js');
    layout();
    var last = n();
    mq.addEventListener && mq.addEventListener('change', function () { if (n() !== last) { last = n(); layout(); } });
    var b = btnWrap && btnWrap.querySelector('button');
    if (b) b.addEventListener('click', function () { shown = items.length; layout(); });
  }
  function all() { document.querySelectorAll('.ab-rf').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
